
angular
	.module('servicepro.modelwidget', [
		'ngResource'
	]);

